{
    "account": {
        "menu": {
            "general_infos": "Info générales",
            "company": "Société",
            "orders_history": "Historique commandes",
            "quotes_history": "Historique devis",
            "invoices_history": "Historique factures",
            "logout": "Logout"
        },
        "general_infos": {
            "title": "Info générales",
            "account_infos": "Info account",
            "user_name": "Nom d'utilisateur",
            "user_email": "E-mail",
            "user_role": "Fonction",
            "user_mobile": "Portable",
            "change_password": "Modifier le mot de passe",
            "agency_infos": "Info société",
            "customer_code": "Code client",
            "company": "Raison sociale",
            "vat": "Numéro TVA",
            "activity": "Secteur d'activité",
            "workers": "Salariés",
            "phone": "Téléphone",
            "country": "Pays",
            "province": "Région",
            "city": "Localité",
            "zip": "Code postal",
            "address": "Adresse"
        },
        "company": {
            "title": "Société",
            "company": "Raison sociale",
            "customer_code": "Code client",
            "name": "Raison sociale",
            "vat": "Numéro TVA",
            "business": "Secteur d'activité",
            "workers": "Salariés",
            "phone": "Téléphone",
            "country": "Pays",
            "province": "Région",
            "city": "Localité",
            "zip": "Code postal",
            "address": "Adresse",
            "operational_users": "Utilisateurs autorisés",
            "table": {
                "user_name": "Nom d'utilisateur",
                "email": "Email",
                "phone": "Portable"
            },
            "no_companies_found": "Aucun résultat trouvé"
        },
        "orders_history": {
            "title": "Historique commandes",
            "label_select_company": "Voir les commandes de la société:",
            "doc_number": "Numéro document",
            "doc_number_placeholder": "ex. 0046100300300",
            "from": "De",
            "to": "à",
            "search_order": "Cherchez la commande",
            "nothing_found": "Aucune commande trouvée",
            "error_reorder": "Une erreur s'est produite pendant l'opération.",
            "table": {
                "order": "Commande",
                "date": "Date",
                "total": "Total",
                "order_status": "Statut commande",
                "reorder": "re-commander",
                "load_more": "Passer d'autres commandes"
            }
        },
        "quotes_history": {
            "title": "Historique devis",
            "label_select_company": "Voir les devis de la société:",
            "doc_number": "Numéro document",
            "doc_number_placeholder": "ex. 0046100300300",
            "from": "De",
            "to": "à",
            "search_quote": "Cherchez le devis",
            "nothing_found": "Aucun devis trouvé",
            "table": {
                "quote": "Devis",
                "date": "Date",
                "new_offer": "Nouveau devis",
                "quote_status": "Statut devis",
                "load_more": "Passer d'autres devis"
            }
        },
        "invoices_history": {
            "title": "Historique factures",
            "label_select_company": "Visualisez situation financière de la société:",
            "expired_invoices": "Factures échues",
            "expiring_invoices": "Factures arrivant à échéance",
            "payment_method": "Type de paiement",
            "billing_address": "Adresse de facturation",
            "nothing_found": "Aucune facture trouvée",
            "table": {
                "invoice_number": "Numéro facture",
                "date": "Date émission",
                "expiring_date": "Date échéance",
                "payment_method": "Type de paiement",
                "value": "Montant à payer",
                "invoice_status": "Statut facture",
                "currency": "Devise",
                "download": "Téléchargez",
                "load_more": "Chargez autres factures",
                "error_download": "Une erreur s'est produite pendant le téléchargement facture"
            }
        },
        "order_detail": {
            "title": "Commande",
            "go_back": "Arrière",
            "download": "Download",
            "your_reference": "Votre référence",
            "date_order": "Date commande",
            "weight": "Poids en kg",
            "payment": "Paiement",
            "return_terms": "Termes de livraison",
            "billing_address": "Adresse de facturation",
            "shipping_address": "Adresse de livraison",
            "table": {
                "art_code": "Réf. Article",
                "art_code_customer": "Réf. Art. client",
                "description": "Désignation",
                "measure_unit": "U. m.",
                "total_quantity": "Qté tot",
                "unit_price": "Prix un.",
                "discount_1": "Rem. 1",
                "discount_2": "Rem. 2",
                "discount_3": "Rem. 3",
                "increase": "Majoration",
                "net_unit_price": "Prix un. net",
                "net_total": "Montant net",
                "deliver_date": "Date livraison"
            }
        },
        "quote_detail": {
            "title": "Devis",
            "go_back": "Arrière",
            "download": "Download",
            "your_reference": "Votre référence",
            "date_quote": "Date devis",
            "weight": "Poids en kg",
            "payment": "Paiement",
            "return_terms": "Termes de livraison",
            "billing_address": "Adresse de facturation",
            "shipping_address": "Adresse de livraison",
            "table": {
                "art_code": "Réf. Article",
                "art_code_customer": "Réf. Art. client",
                "description": "Désignation",
                "measure_unit": "U. m.",
                "total_quantity": "Qté tot",
                "unit_price": "Prix un.",
                "discount_1": "Rem. 1",
                "discount_2": "Rem. 2",
                "discount_3": "Rem. 3",
                "increase": "Majoration",
                "net_unit_price": "Prix un. net",
                "net_total": "Montant net",
                "deliver_date": "Date livraison"
            }
        },
        "document_status_list": {
            "pending": "en cours",
            "delivering": "en consignation",
            "delivered": "livré",
            "processed": "traité",
            "invoiced": "facturé",
            "refused": "refusé",
            "accepted": "accepté",
            "on_customer_approve": "en approbation client",
            "on_offer_progress": "en phase d'offre",
            "canceled": "annulé",
            "expired": "échue",
            "expiring": "arrivant à échéance",
            "paid": "payée",
            "active": "actif",
            "created": "créé",
            "approved": "approuvé",
            "cancelled": "annulé",
            "confirmed": "confirmé"
        },
        "totals_component": {
            "text": "Les conditions générales de fourniture disponibles sur le site www.gberardi.com s'appliquent à tous les contrats de vente par BERARDI BULLONERIE s.r.l. Des conditions contractuelles divergentes, même si elles sont contenues dans des conditions générales ou particulières d'achat rédigées par le client lui-même, ne s'appliquent pas et ne lient BERARDI BULLONERIE s.r.l. que si elles sont expressément acceptées par écrit par ce dernier",
            "products_total": "Numéro articles",
            "discount": "Remise",
            "net_total": "Total net",
            "packaging": "Frais accessoires",
            "shipment": "Transport",
            "order_total": "Total commande"
        }
    },
    "cart": {
        "cart_title": "Mon panier",
        "login_to_receive_quotation": "Connectez-vous ou inscrivez-vous pour demander un devis.",
        "proceed_to_checkout": "Consultez le résumé de la demande.",
        "minimum_order_total": "Minimum de commande 200,00€",
        "code": "Réf. Article",
        "details": "détails",
        "request_quotation": "Demander un devis",
        "request_quotation_text": "Envoyez une demande de devis pour les articles dans le panier d'achat. Vous serez contacté par notre Service Clients.",
        "quote_all": "Demander un devis pour tous les articles",
        "quote": "devis",
        "order_detail": "Détails commande",
        "total_items": "Numéro articles",
        "subtotal": "Sous-total",
        "quantity_discount": "Remise quantité",
        "total_no_vat": "Total hors TVA",
        "vat": "TVA",
        "total": "Total TVA incluse",
        "quote_request": "Demande de devis",
        "pieces": "Pièces",
        "pieces_short": "pcs",
        "quote_request_text": "Le sous-total calculé est provisoire, la demande de devis vise à recalculer le prix dans le cas où la quantité demandée est élevée.",
        "proceed": "Procédez",
        "csv_box_title": "Chargez la liste articles dans le panier",
        "csv_box_text": "Chargez votre fichier .csv avec les réf. articles et les quantités souhaitées.",
        "csv_box_text_instructions": "Insérez vos réf. articles, s'ils sont présents dans notre système, dans la colonne CUSTOMER_CODE",
        "csv_box_no_file": "Aucun fichier .csv chargé",
        "csv_select_file": "Sélectionnez fichier",
        "csv_download": "Download template",
        "csv_upload": "Télécharger",
        "unit_price": "Prix unitaire",
        "error_uploading_csv": "Erreur lors du téléchargement du fichier CSV.",
        "summary": {
            "title": "Récapitulatif",
            "subtitle": "Envoyez la demande à notre service client. Vous pourrez toujours vérifier l'état de la demande dans votre espace personnel.",
            "order_summary": "Récapitulatif commande",
            "addresses": "Adresses",
            "billing_address": "Adresse de facturation",
            "shipping_address": "Adresse de livraison",
            "additional_info": "Informations supplémentaires",
            "your_reference": "Votre référence",
            "input_reference": "Insérez la référence",
            "note": "Note",
            "input_note": "Ajoutez une note",
            "order_items": "Articles commande",
            "items_total": "Tot. articles",
            "discount": "Remise",
            "order_total": "Total commande",
            "order_total_quote": "Demande de devis",
            "quote_summary": "Récapitulatif devis",
            "input_note_quote": "Ajoutez une note au devis",
            "quote_items": "Articles devis",
            "disclaimer": "Les conditions générales de fourniture disponibles sur www.gberardi.com s'appliquent à tous les contrats de vente conclus par BERARDI BULLONERIE s.r.l. Des conditions contractuelles différentes, même si elles sont contenues dans des conditions générales ou particulières d'achat préparées par le client, ne sont pas applicables et ne lient pas BERARDI BULLONERIE s.r.l. sauf si elles sont expressément et par écrit acceptées par cette dernière.",
            "send": "Envoyer",
            "error_send_order_quote": "Une erreur s'est produite lors de l'envoi de la commande."
        },
        "thank_you": {
            "thank_you_title": "Merci de nous avoir choisi!",
            "for_more_info": "Nous avons bien reçu votre demande. Vous pourrez suivre l’avancement de la demande dans votre espace personnel.",
            "back_to_home": "Retour à l'accueil",
            "order_title": "Commande",
            "order_title_failed": "Commande envoyée",
            "order_not_success": "Votre commande nécessite une vérification par un de nos opérateurs. Dès que la vérification sera terminée, vous trouverez votre commande dans la section Historique des commandes.",
            "order_success": "La commande a été envoyée avec succès. Vous pourrez bientôt suivre l’état dans votre espace personnel.",
            "items_number": "Numéro article",
            "quote_title": "Demande de devis envoyée",
            "quote_success": "Dans les prochaines heures, vous recevrez un devis de la part de notre opérateur.",
            "quote_not_success": "Votre devis nécessite une vérification de notre part, dès que celle-ci sera terminée, vous recevrez le devis de notre opérateur"
        }
    },
    "product": {
        "buttons": {
            "tech_sheet_download": "Téléchargez fiche technique",
            "compliance_sheet_download": "Téléchargez certificat de conformité"
        },
        "table_data": {
            "code": "Référence",
            "color": "Couleur",
            "brand": "Brand",
            "material": "Matière"
        },
        "filters": {
            "sku": "Référence"
        },
        "table": {
            "art_code": "Réf. Art",
            "art_code_customer": "Réf. Art. Client",
            "weight": "Poids",
            "pieces_per_package": "Pcs boite",
            "unit_price": "Prix unitaire",
            "total_price": "Prix total",
            "number_of_pieces": "Numéro pièces",
            "availability": "Disponibilité",
            "associate": "Associez",
            "login_to_see_price": "Connectez-vous pour voir le prix",
            "pieces": "Pièces",
            "details": "détails",
            "insufficient_qty": "Partiel. disponible",
            "not_available": "Non disponible",
            "available": "Disponible",
            "load_more_variants": "Ajouter autres variantes",
            "added_product": "Article ajouté au panier: "
        },
        "clothing_selector": {
            "color": "Couleur",
            "size": "Taille",
            "unit_price": "Prix unitaire",
            "pieces_number": "Numéro pièces",
            "total_price": "Prix total",
            "add_to_cart": "Ajouter au panier",
            "insufficient_qty": "Partiel. disponible",
            "not_available": "Non disponible",
            "available": "Disponible"
        }
    },
    "modals": {
        "general": {
            "confirm": "Confirmez",
            "cancel": "Annulez"
        },
        "associate_id": {
            "title": "Référence article client",
            "paragraph": "Tapez votre code client à associer à l'article.",
            "customer_code": "Réf. Art. Client",
            "placeholder": "Tapez numéro client",
            "warning_text": "Attention! Champ modifiable une seule fois!",
            "explanation_confirm": "Vérifiez que le code client est correct et confirmez l'association. Il ne peut pas être changé par la suite en autonomie. Pour modifier le code, vous devrez contacter le service clientèle de Berardi Bullonerie s.r.l.",
            "associate_button": "Associez"
        }
    },
    "search": {
        "search_code": "Recherchez par référence...",
        "cod_art": "Réf. article",
        "name_art": "Désignation article",
        "no_product_found": "Aucun article trouvé",
        "no_query": "Tapez dans la barre de recherche et appuyez sur Entrée afin de recevoir les résultats"
    },
    "general": {
        "login": "Connectez-vous",
        "sign_up": "Inscrivez-vous",
        "select": "Sélectionnez"
    }
}
